import React, { useState, useEffect } from "react";
import { makeStyles, Box, Button, CircularProgress } from "@material-ui/core";
import { bhpColor } from "styles/globals";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    backgroundColor: "#f5f5f5",
    padding: theme.spacing(2),
    borderRadius: "4px",
    marginBottom: theme.spacing(2),
    gap: theme.spacing(2),
    minHeight: "100px",
  },
  imageContainer: {
    flex: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    minHeight: "100px",
    "&:hover": {
      opacity: 0.8,
    },
  },
  image: {
    maxWidth: "100%",
    maxHeight: "100px",
    objectFit: "contain",
  },
  buttonContainer: {
    display: "flex",
    gap: theme.spacing(1),
  },
  hubstarButton: {
    backgroundColor: bhpColor.orange1,
    color: "white",
    textTransform: "none",
    fontWeight: 600,
    "&:hover": {
      backgroundColor: bhpColor.orange2,
    },
  },
  loadingContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "40px",
    marginBottom: theme.spacing(2),
  },
}));

const HUBSTAR_URL = "https://bhp.smartway2book.com.au/se/#/week-view";
const SHAREPOINT_URL =
  "https://spo.bhpbilliton.com/sites/globalproperty/SitePages/HubStar.aspx?csf=1&web=1&e=WLaG7Y&CID=2491be63-478a-4be9-9752-f63809735f10";

export const HubstarBanner = ({}) => {
  const classes = useStyles();
  const [imageUrl, setImageUrl] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [imageError, setImageError] = useState(false);

  useEffect(() => {
    async function fetchImageUrl() {
      try {
        const response = await fetch("api/hubstar_banner_images/?name=Banner");
        const data = await response.json();
        if (response.ok) {
          setImageUrl(data.results[0].picture);
          setIsLoading(false);
          return;
        }
      } catch (err) {
        console.error("Error loading banner image:", err);
      } finally {
        setIsLoading(false);
      }
    }
    fetchImageUrl();
  }, []);

  const handleImageClick = () => {
    window.open(SHAREPOINT_URL, "_blank");
  };

  const handleHubstarButtonClick = () => {
    window.open(HUBSTAR_URL, "_blank");
  };

  if (isLoading) {
    return (
      <Box className={classes.loadingContainer}>
        <CircularProgress size={40} />
      </Box>
    );
  }

  if (imageError || !imageUrl) {
    return null;
  }

  return (
    <Box className={classes.root}>
      <Box className={classes.imageContainer} onClick={handleImageClick}>
        <img
          src={imageUrl}
          alt="HubStar Banner"
          className={classes.image}
          onError={() => setImageError(true)}
        />
      </Box>
      <Box className={classes.buttonContainer}>
        <Button
          variant="contained"
          className={classes.hubstarButton}
          onClick={handleHubstarButtonClick}
        >
          Go to HubStar
        </Button>
      </Box>
    </Box>
  );
};

export default HubstarBanner;
